import visibilityOffV2SVG from '../../assets/icons/visibility-off-v2.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const VisibilityOffV2Icon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={visibilityOffV2SVG} {...props} />;
};
